import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsCondicaoPagamentoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/condicao-pagamento');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Condicao Pagamento');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/condicao-pagamento', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Condicao Pagamento');
    }
  }

  async indexFilters(queries = {}) {
    try {
      const { data } = await this.api.get('/condicao-pagamento', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Condicao Pagamento');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/condicao-pagamento', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Condicao Pagamento');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/condicao-pagamento/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Condicao Pagamento');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/condicao-pagamento/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Condicao Pagamento');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/condicao-pagamento/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Condicao Pagamento');
    }
  }

  async geUltimoCondPagPedidoCliente(clienteId, queries) {
    try {
      const { data } = await this.api.get(`/condicao-pagamento/geUltimoCondPagPedidoCliente/${clienteId}`, { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Condicao Pagamento');
    }
  }

  async GetCondPagtoByClienteId(clienteId, queries) {
    try {
      const { data } = await this.api.get(`/condicao-pagamento/GetCondPagtoByClienteId/${clienteId}`, { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Condicao Pagamento');
    }
  }
}
